import IconCatch from '@/components/icons/icon-catch/icon-catch';
import { convertDate, displayDateFormat } from '@/constants/dates';
import useIsMobile from '@/hooks/use-is-mobile';
import { FeatureFlags, useFeatureFlags } from '@/services/feature-flag-provider';
import { Box, Flex, IconArrowRight, Link, Text } from '@cmpsr/components';
import { Link as ReactRouterLink } from 'react-router-dom';
type ReducedRiskEncouragementProps = {
  date: string;
  type: string;
  idType: string;
};

export default function ReducedRiskEncouragement({ date, type, idType }: ReducedRiskEncouragementProps) {
  const { isEnabled } = useFeatureFlags();
  const isRiskTrendTabEnabled = isEnabled(FeatureFlags.IsRiskTrendTabEnabled);

  return (
    <Flex
      as="article"
      alignItems="flex-start"
      gap={5}
      maxW={{ base: '100%', lg: '780px' }}
      backgroundColor="background-light"
      p={{ base: 5, lg: 6 }}
      border="1px solid"
      borderColor="ui-element-divider"
      borderRadius="radii-3"
    >
      <IconCatch
        icon="congrats-nobg-05"
        alt="cancer type icon"
        size="l"
        height="70px"
        w="70px"
        borderRadius="radii-2"
        background="gradient.dark"
        flexShrink={0}
      />
      <Flex w="full" direction="column">
        <Text variant="text-body-meta-regular">Updates Logged {convertDate(date, displayDateFormat)}</Text>
        <Text variant="text-header-L">Great work decreasing your {type} risk!</Text>
        {isRiskTrendTabEnabled ? (
          <Link
            as={ReactRouterLink}
            to={`/risk-assessment/${idType}`}
            variant="primary-alt"
            justifyContent="center"
            w={{ base: '100%', md: 'max-content' }}
            border="2px solid"
            mt={5}
            trailingIcon={<IconArrowRight />}
            aria-label="view trend"
          >
            View trend
          </Link>
        ) : null}
      </Flex>
    </Flex>
  );
}
